import { useState } from 'react';

/**
 * Route-driven sidebar section expansion with a click override.
 * Override resets whenever `routeKey` (typically pathname) changes so
 * sections collapse when navigating away.
 */
export const useSidebarSectionExpanded = (
  isRouteActive: boolean,
  routeKey: string
) => {
  const [override, setOverride] = useState<boolean | null>(null);
  const [prevRouteKey, setPrevRouteKey] = useState(routeKey);

  if (routeKey !== prevRouteKey) {
    setPrevRouteKey(routeKey);
    setOverride(null);
  }

  const expanded = override ?? isRouteActive;

  const onToggle = () => {
    setOverride(!(override ?? isRouteActive));
  };

  return { expanded, onToggle };
};
